const React = require('react');
import UpdateIcon from '@material-ui/icons/Update';
const BtnTableGlobal = require('../BtnTableGlobal');

module.exports = ({update}) => (
  <BtnTableGlobal
    icon={UpdateIcon}
    text="upd"
    onClick={update}
    testId="tableUpdate"
  />
)
